import React, { useState } from "react";
import * as S from "./styles.ts";
import Input from "../Inputs/Input/index.tsx";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationHospitalSchema } from "../../schemas/validationSchema.ts";
import { InputMaskEnum } from "../../enums/InputMask.ts";
import { Hospital } from "../../models/Hospital.ts";
import { Response } from "../../types/Api.ts";
import hospitalService from "../../services/hospitalService.ts";
import { useFeedback } from "../../contexts/FeedbackContext.tsx";
import Loading from "../Loading/index.tsx";
import { useNavigate } from "react-router-dom";

const CadastroHospital: React.FC<{
  onAdd?: (response: Response<Hospital>) => void;
}> = ({ onAdd }) => {
  const { showFeedback } = useFeedback();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationHospitalSchema),
  });

  const createHospital = (data: any) => {
    return new Hospital(0, data.nome, data.cnpj);
  };

  const onSubmit = async (data: any) => {
    const hospital: Hospital = createHospital(data);
    try {
      setIsLoading(true);
      const response: Response<Hospital> = await hospitalService.create(
        hospital
      );
      showFeedback(response.message, "success");
      if (onAdd) onAdd(response);
      else navigate("/hospital/listagem");
    } catch (error) {
      showFeedback(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <S.Form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit)(e); }}>
      <S.InputGroup>
        <Input
          label="Nome do Hospital*"
          variant="outlined"
          register={register("nome")}
          error={errors.nome}
          helperText={errors.nome?.message}
        />
        <Input
          label="CNPJ*"
          variant="outlined"
          register={register("cnpj")}
          error={errors.cnpj}
          helperText={errors.cnpj?.message}
          format={InputMaskEnum.CNPJ}
        />
      </S.InputGroup>

      <S.SubmitButton variant="contained" color="primary" type="submit">
        {isLoading ? <Loading color="white" /> : "Cadastrar"}
      </S.SubmitButton>
    </S.Form>
  );
};

export default CadastroHospital;
